import type { PostContentObjectDetail, PostContentObjectList } from 'models';
import { Attachments } from 'features/attachments';
import { ContentObjectTextContent } from '../../../../content-object-text-content';

type P = {
  item: PostContentObjectDetail | PostContentObjectList;
};

const PostRendererBody = ({ item }: P) => (
  <>
    <ContentObjectTextContent
      contentId={item.post.id}
      htmlContent={item.post.htmlContent}
      itemType={item.type}
      textContent={item.post.textContent}
      title={item.post.title}
    />
    <Attachments attachments={item.attachments} />
  </>
);

export default PostRendererBody;
